import { useState } from "react"
import cc from "classcat"
import { Icon } from "./Icon"

export interface DropdownProps {
  id: string
  valueLabel: string
  icon?: string
  open?: boolean
  staticLayout?: boolean
  detachedPanel?: boolean
  small?: boolean
  onOpen?: () => void
  onClose?: () => void
  children: (props: any) => JSX.Element
  panelClassName?: string
  className?: string
}

interface ChildProps {
  open: () => void
  close: () => void
}

export const Dropdown = ({
  id,
  valueLabel,
  icon,
  open = false,
  staticLayout = false,
  detachedPanel = false,
  small = false,
  onOpen,
  onClose,
  children,
  className,
  panelClassName,
}: DropdownProps) => {
  const [isOpen, setIsOpen] = useState(open)
  const contentId = `${id}__content`

  const handleOpen = () => {
    setIsOpen(true)
    onOpen?.()
  }

  const handleClose = () => {
    setIsOpen(false)
    onClose?.()
  }

  const childProps: ChildProps = {
    open: handleOpen,
    close: handleClose,
  }

  return (
    <div
      className={cc([
        "dropdown__wrapper",
        !staticLayout && "dropdown__wrapper--floating",
        small && "dropdown__wrapper--small",
      ])}
    >
      <div
        id={id}
        className={cc([
          className,
          "dropdown",
          isOpen && "dropdown--open",
          detachedPanel ? "dropdown--detached" : "dropdown--attached",
          small && "dropdown--small",
        ])}
      >
        <button
          className="dropdown__button"
          aria-expanded={isOpen}
          aria-controls={contentId}
          onClick={isOpen ? handleClose : handleOpen}
        >
          {icon && <Icon name={icon} className="dropdown__button__icon" />}
          <div className="dropdown__button__label">{valueLabel}</div>
          <Icon name="caret_down" className="dropdown__button__caret w-3 h-3" />
        </button>

        <div
          id={contentId}
          className={cc([
            panelClassName,
            "dropdown__panel",
            isOpen && "dropdown__panel--open",
          ])}
          hidden={!isOpen}
        >
          {children(childProps)}
        </div>
      </div>
    </div>
  )
}
